/**
 * Utilities for Component instance and root nodes in JSON node format
 */

import type {JSONNode} from '@packages/shared/types/JSONNode';
import {
  isSymbolRoot as _isSymbolRoot,
  isLibrarySymbolRoot as _isLibrarySymbolRoot,
} from '@packages/systems/core/utils/DomTypeUtils';

export function isSymbolRoot(node: JSONNode) {
  return Boolean(node.data && _isSymbolRoot(node.data));
}

export function isLibrarySymbolRoot(node: JSONNode) {
  return Boolean(node.data && _isLibrarySymbolRoot(node.data));
}

export function getSymbolRootIdFromInstance(
  node: JSONNode
): string | undefined {
  if (
    node.data &&
    node.data.sym &&
    node.data.sym.inst &&
    typeof node.data.sym.inst === 'string'
  ) {
    return node.data.sym.inst;
  }
  return undefined;
}
